import React from "react";

type Props = {
  label: string; // example: "+ €5.000" or "− €3.500"
  intent?: "positive" | "negative";
  onClick: () => void;
};

const DifferenceAdjustButton: React.FC<Props> = ({ label, intent = "positive", onClick }) => {
  const btnClass = intent === "positive" ? `positive` : `negative`;

  return (
    <button type="button" className={btnClass} onClick={onClick}>
      {label}
    </button>
  );
};

export default DifferenceAdjustButton;
